var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSim(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LogoSIM") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.016 0l-.248.142v.003l-2.069 3.59-1.225 2.125L8.17 9.856l2.303 3.993 3.569 6.19 1.065 1.85-1.225 2.122.012.02h-.024l.012-.02-2.29-3.972-2.345-4.067-2.302-3.993-2.3 3.993-2.344 4.067L0 24.032h4.602l2.302-3.993.042-.074.044.074 2.3 3.993 2.29 3.975L13.884 32l2.303-3.996 1.222-2.122v-.003l1.065-1.847 1.237-2.146-1.065-1.847-1.237-2.146-4.632-8.04 1.225-2.122 4.632 8.04 2.303 3.992.16.276 2.299 3.993H28l-2.303-3.993-2.459-4.269-2.302-3.993-4.635-8.04-2.09-3.624z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSim);
export default __webpack_public_path__ + "static/media/logo-SIM.cc9c286441947a8ae1c9c009c19016ca.svg";
export { ForwardRef as ReactComponent };